<div *ngIf="routeModel">
  <tj-routes [route]="routeModel"></tj-routes>
</div>
